import React, { useState } from 'react';
import {
  FaFacebook,
  FaGithub,
  FaLinkedinIn,
  FaMediumM,
  FaStackOverflow,
  FaTwitter,
} from 'react-icons/fa';
import { contactsData } from '../../../data/contactsData';
import { canNativeShare, saveContact, shareSite } from '../../../utils/contactCard';
import Reveal from '../../helper/reveal';
import './contacts.css';

const socials = [
  { key: 'github', label: 'GitHub', Icon: FaGithub },
  { key: 'linkedIn', label: 'LinkedIn', Icon: FaLinkedinIn },
  { key: 'stackOverflow', label: 'Stack Overflow', Icon: FaStackOverflow },
  { key: 'medium', label: 'Medium', Icon: FaMediumM },
  { key: 'twitter', label: 'X (Twitter)', Icon: FaTwitter },
  { key: 'facebook', label: 'Facebook', Icon: FaFacebook },
];

const ContactUI = () => {
  const [copied, setCopied] = useState(false);
  const [note, setNote] = useState('');

  const announce = (message) => {
    setNote(message);
    setTimeout(() => setNote(''), 2500);
  };

  const onSave = () => {
    saveContact();
    announce('Contact card downloaded');
  };

  const onShare = async () => {
    const outcome = await shareSite();
    if (outcome === 'copied') announce('Link copied');
    if (outcome === 'failed') announce('Could not share. Copy the address bar instead.');
  };

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(contactsData.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (e) {
      // Clipboard unavailable (insecure context / permissions): the mailto link still works.
    }
  };

  return (
    <section className='section contacts' id='contacts' aria-labelledby='contacts-title'>
      <div className='container'>
        <Reveal className='section-head'>
          <span className='eyebrow'>10 / Contact</span>
          <h2 id='contacts-title' className='section-title'>Let's build something together.</h2>
        </Reveal>

        <Reveal className='contacts__body'>
          <div className='contacts__primary'>
            <p className='contacts__lead'>
              Open to conversations about software engineering and computer vision roles, remote or
              on-site. The fastest way to reach me is email.
            </p>
            <a className='contacts__email display' href={`mailto:${contactsData.email}`}>
              {contactsData.email}
            </a>
            <div className='contacts__buttons'>
              <a className='btn btn--primary' href={`mailto:${contactsData.email}`}>Send an email</a>
              <button type='button' className='btn' onClick={copyEmail}>
                {copied ? 'Copied' : 'Copy address'}
              </button>
              <button type='button' className='btn' onClick={onSave}>Save contact</button>
              <button type='button' className='btn' onClick={onShare}>
                {canNativeShare() ? 'Share' : 'Copy site link'}
              </button>
              <span className='sr-only' role='status' aria-live='polite'>
                {copied ? 'Email address copied to clipboard' : note}
              </span>
            </div>
          </div>

          <dl className='contacts__details'>
            <div>
              <dt>Location</dt>
              <dd>{contactsData.address}</dd>
            </div>
            {contactsData.phone && (
              <div>
                <dt>Phone</dt>
                <dd><a href={`tel:${contactsData.phone.replace(/\s/g, '')}`}>{contactsData.phone}</a></dd>
              </div>
            )}
            <div>
              <dt>Elsewhere</dt>
              <dd>
                <ul className='contacts__social'>
                  {socials.filter(({ key }) => contactsData[key]).map(({ key, label, Icon }) => (
                    <li key={key}>
                      <a href={contactsData[key]} target='_blank' rel='noreferrer' aria-label={`${label} (opens in a new tab)`}>
                        <Icon aria-hidden='true' />
                        <span>{label}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </dd>
            </div>
          </dl>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactUI;
